import { render, staticRenderFns } from "./clipIcon.vue?vue&type=template&id=51745752&functional=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51745752')) {
      api.createRecord('51745752', component.options)
    } else {
      api.rerender('51745752', component.options)
    }
    module.hot.accept("./clipIcon.vue?vue&type=template&id=51745752&functional=true&", function () {
      api.rerender('51745752', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/listView/table/icons/clipIcon.vue"
export default component.exports